

export const enum Passes {
  COLOR = 'color',
  DEPTH = 'depth',
  REFLECT_DEPTH = 'reflect-depth',
  DEFAULT = COLOR
}